import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const SignUpComponent = React.lazy(() => import("../Components/RootComponents/SignUpComponent"));
const SignUpPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SignUpComponent />
      </Suspense>
    </Fragment>
  );
};

export default SignUpPage;
